module.exports = __webpack_public_path__ + "static/img/4337_phase_function_Paper_PointsHejduk_Prediction.5eb856a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4337_phase_function_Paper_PointsHejduk_Prediction.png
// module id = cpWw
// module chunks = 0